import React from "react";
import { Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWrench,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";

export default function MySurvey({ setShowSurvey }) {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
      <Card
        className="text-center border-0"
        style={{
          borderRadius: "20px",
          maxWidth: "560px",
          width: "100%",
          boxShadow: "0 4px 24px rgba(0, 0, 0, 0.08)",
          border: "1px solid #e2e8f0",
        }}
      >
        <Card.Body className="p-5">
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "20px",
              background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 1.5rem",
              boxShadow: "0 8px 24px rgba(99, 102, 241, 0.3)",
            }}
          >
            <FontAwesomeIcon icon={faWrench} style={{ color: "#fff", fontSize: "2rem" }} />
          </div>

          <h3 style={{ fontWeight: "700", color: "#1e293b", marginBottom: "0.75rem" }}>
            Custom Survey Builder
          </h3>

          <p style={{ color: "#64748b", fontSize: "1rem", lineHeight: "1.6", marginBottom: "1.5rem" }}>
            The full custom survey builder with drag-and-drop question design,
            branding options, and advanced logic is available in the dedicated
            Survey application.
          </p>

          <div
            className="p-3 rounded mb-4"
            style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}
          >
            <p className="mb-0" style={{ color: "#475569", fontSize: "0.9rem" }}>
              You can still use the <strong>default templates</strong> (CSAT 5, CSAT 10, NPS)
              directly from this portal and assign them to your Zendesk groups.
            </p>
          </div>

          <Button
            variant="outline-secondary"
            onClick={() => setShowSurvey(false)}
            style={{
              borderRadius: "10px",
              padding: "0.625rem 1.5rem",
              fontWeight: "600",
            }}
          >
            Back to Templates
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
}
